import { Store } from '.';
import { SiteMetaData, SiteSelectorData } from '../../types';

export type SiteSelectorSlice = SiteSelectorData & {
  setUserSelectedSite: (site?: SiteMetaData | null) => void;
};

export const getSiteSelectorInitialState = (
  set: (stateUpdater: (state: Store) => Partial<Store>) => void
): SiteSelectorSlice => ({
  sites: [],
  itemsCount: 0,
  selectedSite: undefined,
  lastInteractedSite: null,
  setUserSelectedSite: (site?: SiteMetaData | null) => {
    set((state) => ({
      siteSelectorSlice: {
        ...state.siteSelectorSlice,
        selectedSite: site,
      },
    }));
  },
});
